import { computed, createApp, onMounted } from 'vue'
import { useStore } from '@nanostores/vue'
import initIntercom from '@/legacy/ts/initIntercom'
import languageDataGenerator from '@/legacy/ts/languageDataGenerator'
import { pageName } from '@/store/pageName'

const pageNameGlobal = useStore(pageName)

// @ts-ignore
globalThis.__VUE_OPTIONS_API__ = true
// @ts-ignore
globalThis.__VUE_PROD_DEVTOOLS__ = true

window.BsFooterVm = createApp({
	name: 'Footer',
	setup() {
		const isShowPCSFooter = computed(() => {
			return pageNameGlobal.value !== ''
		})
		const ContentFooter = computed(() => {
			return isShowPCSFooter.value
				? window.FooterContentPCS
				: window.FooterContent
		})
		const currentCountryName = computed(() => {
			return window.BUYANDSHIP.settings.all_countries[
				window.BUYANDSHIP.settings.current_country2.id
			].name
		})
		const isShowTwoLayer = computed(() => {
			return ContentFooter.value.nav.length > 3
		})

		function showLanguagePopup() {
			window.BsHeaderVm.showLanguagePopup()
		}

		onMounted(() => {
			if (!import.meta.env.PROD) {
				initIntercom()
			}
		})

		return {
			ContentFooter,
			currentCountryName,
			isShowTwoLayer,
			showLanguagePopup,
		}
	},
})
	.use(languageDataGenerator)
	.mount('#bsFooter')
